import React from "react";
import styled from "styled-components";

import utils from "../../../services/utils.service";

const Wrapper = styled.div`
  padding: 16px;
  @media (max-width: 400px) {
    padding: unset;
  }
`;

export const H3 = styled.h3`
  letter-spacing: 1.6px;
  font-family: Lato;
  color: #283678;
  border: none;
  font-size: 20px;
  text-align: right;
`;

const Value = styled.div`
  font-size: medium;
  margin-top: 5px;
  line-height: 1.2;
  white-space: pre-wrap;
  @media (max-width: 420px) {
    font-size: 14px;
  }
`;

const titleMapper = function (key) {
  const mapping = {
    about: "About the company",
    tech_stack: "Tech Stack",
    values_and_culture: "Core values",
    technical_challenges: "Main technical challenges",
    impact: "Describe the impact",
    core_team_highlights: "Core team highlights",
    size_and_team_breakdown: "Team size & breakdown",
    founder_bios: "Founder bios",
    engineering_culture: "Engineering culture",
    mentorship_opportunities: "Mentorship opportunities",
    funding_highlights: "Funding highlights",
    recognition_and_press: "Awards, recognition & press",
    perks_and_benefits: "Perks",
    locations: "Locations",
    year_founded: "Year founded",
    website: "Company website",
  };

  return mapping[key];
};

export default (props) => {
  const { companyInfo } = props;

  return (
    <Wrapper>
      <div className="info-section">
        <h3 className="sub-title">General</h3>
        <hr />
      </div>

      {props.companyInfo
        ? Object.entries(companyInfo)
            .filter(([key]) => titleMapper(key))
            .map(([key, val], idx) => {
              if (!val) return null;

              if (key === "locations") val = val.map(({ city }) => city);

              if (Array.isArray(val)) val = val.join(", ");
              if (typeof val === "string") {
                val = utils.airtableMultilineToHtml(val);
              }

              return (
                <div key={idx} className="company-info">
                  <h2>{titleMapper(key)}</h2>
                  <Value
                    style={{
                      marginTop: "5px",
                      lineHeight: "1.2",
                    }}
                    dangerouslySetInnerHTML={{ __html: val }}
                  />
                </div>
              );
            })
        : null}
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/components/Modals/Company/CompanyInfo.js